import React, { useState, useEffect } from 'react';
import get from 'lodash/get';
import take from 'lodash/take';
import ListGroup from 'jbc-front/components/ListGroup';
import { recordDisplay, isDateInPast } from 'src/utils/Utils';
import styles from './SystemAnnounces.scss';
import { useTranslation } from 'react-i18next';

import { Notification } from 'jbc-front/components/icons';
import { setCache, getCache } from 'src/Cache';
import Button from 'jbc-front/components/Button';
import { openNewTab } from 'src/utils/Http';
import Icon from 'react-icon-base'

const MAX_DISPLAY = 6;


const PostPin = props => (
  <Icon viewBox="0 0 89 88" {...props}>
    <g fill='none' fillRule='evenodd' stroke='currentColor'>
      <path d="M 89.011 87.739 c -0.599 -1.371 -1.294 -2.652 -1.968 -3.891 l -0.186 -0.343 l -15.853 -15.91 c -0.371 -0.375 -0.746 -0.748 -1.12 -1.12 c -0.671 -0.667 -1.342 -1.335 -1.997 -2.018 l -1.459 -1.437 l 23.316 -23.317 l -1.704 -1.704 c -9.111 -9.112 -22.925 -12.518 -35.353 -8.759 l -6.36 -6.359 c 0.769 -7.805 -2.017 -15.69 -7.503 -21.175 L 37.123 0 L 0 37.122 l 1.706 1.704 c 5.487 5.487 13.368 8.271 21.176 7.503 l 6.36 6.36 C 25.484 65.115 28.889 78.93 38 88.041 l 1.703 1.704 l 23.316 -23.316 l 1.438 1.458 c 0.679 0.653 1.344 1.321 2.009 1.989 c 0.373 0.374 0.745 0.748 1.117 1.116 l 15.699 15.7 l 0.566 0.352 c 1.239 0.673 2.52 1.369 3.891 1.968 L 90 90 L 89.011 87.739 z" strokeWidth='10' strokeLinecap='round' />
    </g>
  </Icon>
)
PostPin.defaultProps = {
  size: 30
}

export const tabColor = (isNotice) => {
  return isNotice ? "#d5eefb" : ""
}

export const showDateNewLine = date => date.replace(/年/, '年\n');

export const updateNotification = (lastViewed, systemAnnounces) => {
  //unread notification counter
  const generalCount = systemAnnounces.general.filter(item => isDateInPast(lastViewed, item.publishAt)).length
  const pinnedCount = systemAnnounces.pinned.filter(item => isDateInPast(lastViewed, item.publishAt)).length
  const summaryCount = generalCount + pinnedCount
  // if (summaryCount == 0) {
  //   return ""
  // }
  if (summaryCount > 6) {
    return "6+"
  }
  return String(summaryCount)
}

const SystemAnnounces = ({ systemAnnounces }) => {
  const { t, i18n } = useTranslation();
  const [toggleCollapse, settoggleCollapse] = useState(false)
  const [notificationCount, setnotificationCount] = useState("")
  const [lastSeen, setlastSeen] = useState("")
  const [isNotice, setisNotice] = useState(updateNotification(getCache('last_viewed'), systemAnnounces) != "0")

  const MAX_DISPLAY = 6;
  const MAX_PINNED = (() => {
    const generalCount = systemAnnounces.general.length
    const pinnedCount = systemAnnounces.pinned.length
    if (pinnedCount >= 3 && generalCount >= 3) return 3;
    if (pinnedCount >= 3 && generalCount < 3) return Math.min(pinnedCount, 6 - generalCount);
    return pinnedCount;
  })()

  useEffect(() => {
    //get lastSeen for displaying normal or disabled text 
    setlastSeen(getCache('last_viewed'))
    setnotificationCount(updateNotification(getCache('last_viewed'), systemAnnounces))
  }, [])

  const handleOnclick = (e) => {
    e.preventDefault()
    //toggle on/off for Announcement Tab
    settoggleCollapse(!toggleCollapse);

    //update localStorage when user has seen new announcement
    if (notificationCount) {
      setCache('last_viewed', new Date().toISOString())
    }
    setnotificationCount(updateNotification(getCache('last_viewed'), systemAnnounces))
  }

  return (
    <ListGroup className={styles.tab}>
      <ListGroup.Title id="tabTitle" style={{ borderBottom: 'solid 1px #ddd', display: "flex", backgroundColor: tabColor(isNotice) }}>{
        <React.Fragment>
          {t('features.Dashbord.components.SystemAnnounces.announcement')}
          <div className={styles.wrap}>
            <Button id="more" borderLight widthAuto
              style={{ minWidth: "auto", border: "none", backgroundColor: "transparent" }}
              onClick={() => openNewTab('/system_announces')}>
              {t('features.Dashbord.components.SystemAnnounces.show_all')}
            </Button>
            {/* | */}
            <Button id="toggle" widthAuto primary={isNotice} borderLight={!isNotice}
              onClick={(e) => handleOnclick(e)}
              // style={{ minWidth: "auto", backgroundColor: "transparent", display: "flex", alignItems: "center" }}
              style={{ backgroundColor: !isNotice ? "transparent" : "" }}
            >
              {notificationCount ? (<span>{notificationCount}</span>) : (<span></span>)}
              <Notification size={20} />

            </Button>
          </div>

        </React.Fragment>
      }
      </ListGroup.Title>
      <div className={styles.announceCollapseWrap} style={toggleCollapse ? { maxHeight: "450px" } : {}}>
        {(get(systemAnnounces.general, 'length') == 0) && (get(systemAnnounces.pinned, 'length') == 0) ? (
          <ListGroup.Item id="emptyItem" className={styles.empty}>{t('features.Dashbord.components.SystemAnnounces.no_announcement')}</ListGroup.Item>
        ) : (<React.Fragment>

          {take(systemAnnounces.pinned, MAX_PINNED).map(systemAnnounce => (
            <ListGroup.Item
              id="pinnedItem"
              className={styles.list}
              key={systemAnnounce.id}
              {...(systemAnnounce.systemAnnounceType === 'link'
                ? { href: systemAnnounce.link, target: '_blank', as: 'a' }
                : { href: `/system_announces/${systemAnnounce.id}`, as: 'a' })}
            >
              <span className={styles.date}>{showDateNewLine(recordDisplay.dateOrTime(systemAnnounce.publishAt))}</span>
              <PostPin size={13} color='#3498db' style={{ marginLeft: "5px", transform: "rotate(90deg)", verticalAlign: "baseline" }} />
              <span
                className={`${styles.title} ${isDateInPast(systemAnnounce.publishAt, lastSeen) ? styles.seen : ""} ${styles.pinned}`}
              >
                {systemAnnounce.title}</span>
              <ListGroup.Icon />
            </ListGroup.Item>
          ))}

          {take(systemAnnounces.general, MAX_DISPLAY - (Math.min(get(systemAnnounces.pinned, 'length'), MAX_PINNED))).map(systemAnnounce => (
            <ListGroup.Item
              id="generalItem"
              className={styles.list}
              key={systemAnnounce.id}
              {...(systemAnnounce.systemAnnounceType === 'link'
                ? { href: systemAnnounce.link, target: '_blank', as: 'a' }
                : { href: `/system_announces/${systemAnnounce.id}`, as: 'a' })}
            >
              <span className={styles.date}>{showDateNewLine(recordDisplay.dateOrTime(systemAnnounce.publishAt))}</span>
              <div className={`${styles.title} ${isDateInPast(systemAnnounce.publishAt, lastSeen) ? styles.seen : ""}`}
                style={{ marginLeft: "18px" }}>
                {systemAnnounce.title}
              </div>
              <ListGroup.Icon />
            </ListGroup.Item>
          ))}
        </React.Fragment>
        )}
      </div>
    </ListGroup>
  );
};

export default SystemAnnounces;
